import { render, staticRenderFns } from "./AdsList.vue?vue&type=template&id=09cc4760&scoped=true&"
import script from "./AdsList.vue?vue&type=script&lang=js&"
export * from "./AdsList.vue?vue&type=script&lang=js&"
import style0 from "./AdsList.vue?vue&type=style&index=0&id=09cc4760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc4760",
  null
  
)

export default component.exports